var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00361F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,122.9c-6.2,0-11.2-5-11.2-11.2V70c0-6.2,5-11.2,11.2-11.2h47.3c6.2,0,11.2,5,11.2,11.2v41.7 c0,6.2-5,11.2-11.2,11.2C101.8,122.9,54.5,122.9,54.5,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,233c-6.2,0-11.2-5-11.2-11.2v-41.7c0-6.2,5-11.2,11.2-11.2h47.3c6.2,0,11.2,5,11.2,11.2v41.7 c0,6.2-5,11.2-11.2,11.2H54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,343.1c-6.2,0-11.2-5-11.2-11.2v-41.7c0-6.2,5-11.2,11.2-11.2h47.3c6.2,0,11.2,5,11.2,11.2v41.7 c0,6.2-5,11.2-11.2,11.2H54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,453.2c-6.2,0-11.2-5-11.2-11.2v-41.7c0-6.2,5-11.2,11.2-11.2h47.3c6.2,0,11.2,5,11.2,11.2V442 c0,6.2-5,11.2-11.2,11.2H54.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.6,105.9H187.4c-8.3,0-15.1-6.7-15.1-15.1s6.8-15.1,15.1-15.1h266.2c8.3,0,15.1,6.7,15.1,15.1 S461.9,105.9,453.6,105.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.6,216H187.4c-8.3,0-15.1-6.7-15.1-15.1s6.8-15.1,15.1-15.1h266.2c8.3,0,15.1,6.7,15.1,15.1 S461.9,216,453.6,216z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.6,326.1H187.4c-8.3,0-15.1-6.7-15.1-15.1c0-8.3,6.8-15.1,15.1-15.1h266.2c8.3,0,15.1,6.7,15.1,15.1 S461.9,326.1,453.6,326.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.6,436.2H187.4c-8.3,0-15.1-6.7-15.1-15.1c0-8.3,6.8-15.1,15.1-15.1h266.2c8.3,0,15.1,6.7,15.1,15.1 S461.9,436.2,453.6,436.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListA);
export default __webpack_public_path__ + "static/media/listA.e73d980e4d3cbc95304b21ce5d671941.svg";
export { ForwardRef as ReactComponent };